var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isNotNullOrUndefined(_vm.logo))?_c('base-link',{staticClass:"logo",attrs:{"link":_vm.rootUrl}},[_c('base-image',{staticClass:"lazypreload",attrs:{"url":_vm.logo.url,"width":_vm.width,"height":_vm.height,"format":_vm.imageType,"format-extra":[_vm.imageType],"image-class":"logo__image","preload":true,"responsive":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }